module.exports = __webpack_public_path__ + "img/2.6ff8bd52.png";